module.exports = __webpack_public_path__ + "asset/image-ic_category_17-399a8d94e24b7d04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_17.svg
// module id = Nxgv
// module chunks = 0